  document.getElementById('toggle').addEventListener('click', function () {
  var menu = document.getElementById('menu');
  if (menu.style.display === 'block') {
    menu.style.display = 'none';
  } else {
    menu.style.display = 'block';
  }
});
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.read-more-toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        const parent = this.closest('.split-text');
        const shortText = parent.querySelector('.short-text');
        const fullText = parent.querySelector('.full-text');
        
        const isExpanded = fullText.style.display === 'inline';
        if (isExpanded) {
          shortText.style.display = 'inline';
          fullText.style.display = 'none';
          this.textContent = 'read more...';
        } else {
          shortText.style.display = 'none';
          fullText.style.display = 'inline';
          this.textContent = 'read less...';
        }
      });
    });
  });

